import { Paper, Typography } from "@mui/material";
import React from "react";
import { TypeSensor } from '../../pages/camaras/interface/camara.interface';
import { NumericFormat } from 'react-number-format';
import moment from "moment";
import { usePageVisibility } from "../../pages/camaras/usePageVisibility";
import Tooltip from '@mui/material/Tooltip';
import { SensorType } from "../Avanzados/interfaces/avanzado.interface";

type CardProps = {
    propsSensor: TypeSensor;
}

export const SetPointComponent: React.FC<CardProps> = ({propsSensor}) => {

    const isPageVisible = usePageVisibility();
    const timerIdRef = React.useRef<NodeJS.Timer | null>(null); 

    const [estado, setEstado] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
            setEstado(false);
        else
            setEstado(true);


        const controllingCallback = () => {
            if (moment().diff(propsSensor.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
                setEstado(false);
            else
                setEstado(true);
        };

        const startPolling = () => {
            timerIdRef.current = setInterval(controllingCallback, 60000); //Cada 1 minuto
        };

        const stopPolling = () => {
            clearInterval(timerIdRef.current!);
        };

        if (isPageVisible) {
            startPolling();
        } else {
            stopPolling();
        }

        return () => {
            stopPolling();
        };

    }, [propsSensor,  isPageVisible]);

    const getValor = (estado: boolean, sensor:TypeSensor) => {
    if (estado)
    {
        switch (sensor.tipo_sensor) {
            case SensorType.SET_POINT_TEMPERATURA:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={'°C'} 
                    decimalScale={1}
                    decimalSeparator=","
                    fixedDecimalScale
                />;
            case SensorType.SET_POINT_PRESION:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' Kg'} 
                    decimalScale={1}
                    decimalSeparator=","
                    fixedDecimalScale
                />;
            case SensorType.SET_POTENCIA:
                return <NumericFormat 
                    value={sensor.valores[0].value} 
                    displayType={'text'} 
                    allowNegative 
                    suffix={' KW'} 
                />;
            default:
                return null;
        }
    }
    else
    {
        switch (sensor.tipo_sensor) {
            case SensorType.SET_POINT_TEMPERATURA:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="black"> 
                    --,- °C
                </Typography>
            case SensorType.SET_POINT_PRESION:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="black"> 
                    --,- Kg
                </Typography>
            case SensorType.SET_POTENCIA:
                return <Typography
                    variant = "subtitle2" 
                    align="center"
                    color="black"> 
                    --- KW
                </Typography>
            default:
                return null;
        }
    }

    }



    return (
        <Paper
            elevation={3}
            sx={{
                padding: 1,
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
                textAlign: "center",
                height: "100%",
            }}
        >
        {
            propsSensor.valores?.length !== 0 && (
                <>
                    <Typography 
                        variant = "caption" 
                    >
                        {propsSensor.name_front}
                        {/*<DeviceThermostatIcon  sx={{verticalAlign:"middle"}} /> */}
                        {/*getSensorIcon(propsSensor.tipo_sensor)*/}
                    </Typography>
                    <Tooltip 
                            title={`Ultima muestra: ${moment(propsSensor.valores[0].fecha_hora_value).format("DD/MM/YYYY HH:mm")}
                            Descirpcion: ${propsSensor.descripcion} `} 
                    >
                        <Typography 
                            variant="subtitle1" 
                            fontWeight="bold" 
                            color="#252850"
                        >
                            {getValor(estado, propsSensor)}
                        </Typography>
                    </Tooltip>

                </>)
        }
        </Paper>
    )
}
